import { render, staticRenderFns } from "./CultureCreate.vue?vue&type=template&id=4705c576"
import script from "./CultureCreate.vue?vue&type=script&lang=js"
export * from "./CultureCreate.vue?vue&type=script&lang=js"
import style0 from "./CultureCreate.vue?vue&type=style&index=0&id=4705c576&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports